function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5981 4.27842V6.05549H17.0599V20.8685H6.91567V6.05549H8.39941V4.27842C8.39941 3.57199 8.97384 3 9.67783 3H14.3197C15.0262 3 15.5981 3.57443 15.5981 4.27842ZM9.68027 3.97776C9.51405 3.97776 9.37961 4.1122 9.37961 4.27842V6.05549H14.6228V4.27842C14.6228 4.1122 14.4884 3.97776 14.3222 3.97776H9.68027ZM5.94525 6.04583V20.8686H3.51797C2.67954 20.8686 2 20.1866 2 19.3506V7.5638C2 6.72537 2.68198 6.04583 3.51797 6.04583H5.94525ZM22 7.5638V19.3506C22 20.1891 21.318 20.8686 20.482 20.8686H18.0548V6.04339H20.482C21.3205 6.04339 22 6.72537 22 7.5638Z",
  fill: "current"
});

var SvgComponent = function SvgComponent(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24"
    }, props), _ref)
  );
};

export default __webpack_public_path__ + "static/media/luggage-lg.8fcb3df3.svg";
export { SvgComponent as ReactComponent };